import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2';
import axios from 'axios';
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller } from "react-hook-form";
import PhoneInput from 'react-phone-number-input/input'
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

export default function AdvertisementAdd() {
    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        reset
    } = useForm();


    const navigate = useNavigate();

    const profile_complete = useSelector(state => state.user.profile_complete);
    useEffect(() => {
        if (profile_complete != true) {
            navigate('/edit_user');
            Swal.fire({
                icon: 'info',
                title: 'Please complete your profile first.',
            });
        }
    }, [profile_complete]);


    const [TotalPay, setTotalPay] = useState(0);
    const [endDate, setEndDate] = useState(0);
    const [MainPrice, setPrice] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [uniqueArray, setuniqueArray] = useState([...Array(32).fill('')]);
    const [count, setCount] = useState(0);
    const [inputValues, setInputValues] = useState([...Array(32).fill('')]);
    const user = useSelector(state => state.user);
    const [yearlySelected, setYearlySelected] = useState('')


    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}?action=getPrice`)
            .then(response => {
                setPrice(response.data.data.price)
                setDiscount(response.data.data.yearlyDiscount)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });

    }, [])


    useEffect(() => {
        console.log('add', user)
        if (user.uid) {
            (async () => {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetUserbyId', id: user.uid });
                const dataEdit = response.data.data;
                console.log('dataEdit')
                reset({
                    firstname: dataEdit.firstname || '',
                    lastname: dataEdit.lastname || '',
                });
            })();
        }

    }, [user, reset]);




    const [fileURL, setFileURL] = useState([]);

    const handleInputChange = (index, event) => {
        const newValue = Number(event.target.value);
        if (newValue && inputValues.some(item => item === newValue)) {
            event.target.classList.add('red-border');
        } else {
            event.target.classList.remove('red-border');
        }

        const newInputValues = [...inputValues];
        newInputValues[index] = newValue;

        setInputValues(newInputValues);
        const uniqueArray = [...new Set(newInputValues)];
        console.log(uniqueArray)
        const nonEmptyValues = uniqueArray.filter((item) => item !== '');
        setCount(nonEmptyValues.length);

        setuniqueArray(nonEmptyValues)
        console.log('newInputValues', nonEmptyValues)
    };
    const calculatePercentage = (part, whole) => {
        if (whole === 0) {
            return 0;
        } else {
            const percentage = (part / 100) * whole;
            const mainvalue = part - percentage
            return mainvalue.toFixed(1);
        }
    }

    const handleImageChange = (event) => {
        const { files } = event.target;
        console.log('adPicture')
        if (files) {
            console.log('rotatedImage', files)
            const images = event.currentTarget.files[0];

            if (typeof (images) === 'object') {
                var reader = new FileReader();

                reader.onload = function (e) {

                    const rotatedImage = {
                        url: e.target.result,
                        rotationAngle: 0,
                    };

                    setFileURL([rotatedImage])
                };
                reader.readAsDataURL(images);
            }
        }
    }

    const handleChange = () => {
        const PaymentType = getValues("PaymentType");
        const oneMonthLater = new Date(getValues("startDate"));
        if (PaymentType === 'YearlyBilling' && uniqueArray.length !== 0) {
            console.log('uniqueArray', uniqueArray)
            if (MainPrice && MainPrice > 0) {
                const thisdates = (getValues("startDate") ? new Date(oneMonthLater.setMonth(oneMonthLater.getMonth() + 12)) : '')
                setEndDate(thisdates)
                const discount = document.getElementById('discount').value;
                const MainPriceValue = `${MainPrice * count}`;
                const MainPriceYearly = MainPriceValue * 12;
                const calculate = calculatePercentage(MainPriceYearly, discount)
                setYearlySelected(
                    <div>
                        <p className='pay2'>Your Total is ${MainPriceValue} * {12} = ${MainPriceYearly} annually.</p>
                        <p className='pay'>You got {discount}% discount on annual payment. Your total amount due is ${calculate}.</p>
                        {getValues("startDate") ? (<p className='EndDate'> Advertisement End Date will be {format(thisdates, 'MM/dd/yyyy')}</p>) : ''}
                        <p className="pay-total">NOTE: You can't add more ZipCodes. If you want to add additional ZipCodes, you'll need to create a new advertisement.But you can edit the existing Zipcodes</p>

                    </div>
                )
                setTotalPay(calculate);
            }
        } else if (PaymentType === 'MonthlyBilling' && uniqueArray.length !== 0) {
            console.log('222')
            const thisdates = (getValues("startDate") ? new Date(oneMonthLater.setMonth(oneMonthLater.getMonth() + 1)) : '')
            setEndDate(thisdates)
            if (MainPrice && MainPrice > 0) {
                setYearlySelected(
                    <div>
                        <p className='pay2'>You have to pay ${MainPrice * count} each month.</p>
                        {getValues("startDate") ? (<p className='EndDate'>  Advertisement End Date will be {format(thisdates, 'MM/dd/yyyy')}</p>) : ''}
                        <p className="pay-total">NOTE: You can't add more ZipCodes. If you want to add additional ZipCodes, you'll need to create a new advertisement.But you can edit the existing Zipcodes</p>
                    </div>
                )
                setTotalPay(MainPrice * count);
            }
        } else {
            console.log('333')
            setYearlySelected('')
        }
    };
    useEffect(() => {
        handleChange();
    }, [count, uniqueArray]);

    const rotateImage = (index) => {
        console.log('fileURL', fileURL)
        setFileURL(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[index].rotationAngle = (updatedImages[index].rotationAngle + 90) % 360;
            return updatedImages;
        });
    };

    const removeImage = (index) => {
        setFileURL([]);
    };

    const openImageModal = (e) => {
        e.preventDefault();
        document.getElementById('imagePreviewModal').classList.add('show');
        document.getElementById('imagePreviewModal').style.display = 'block';
    };


    const closeModal = (event) => {
        event.preventDefault();
        // setPreviewImages([]);
        document.getElementById('imagePreviewModal').classList.remove('show');
        document.getElementById('imagePreviewModal').style.display = 'none';
    };


    const onSubmit = (data) => {
        if (uniqueArray.length <= 0) {
            alert("The value is already present. Please enter a unique value.");
        } else {
            Swal.fire({
                title: 'Saving, please wait',
                html:
                    '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
                showConfirmButton: false,
                showCancelButton: false,
                focusConfirm: false,
            });
            const formData = new FormData();
            formData.append('action', 'AddAd');
            formData.append('firstname', data.firstname);
            formData.append('lastname', data.lastname);
            formData.append('businessName', data.businessName);
            formData.append('businessLicense', data.businessLicense);
            formData.append('email', user.email);
            formData.append('phoneNumber', user.phoneNumber);
            formData.append('startDate', format(data.startDate, 'yyyy/MM/dd H:i:s'));
            formData.append('endDate', format(endDate, 'yyyy/MM/dd H:i:s'));
            formData.append('businessURL', data.businessURL);
            formData.append('ZipCodes', uniqueArray);
            formData.append('TotalPay', TotalPay);
            formData.append('PaymentType', data.PaymentType);
            formData.append('picture', data.adPicture ? data.adPicture : '');
            formData.append('pictureA', fileURL ? fileURL[0].rotationAngle : 0);
            formData.append('ownerID', user.uid);
            formData.append('ownerEmail', user.email);
            formData.append('userStatus', 1);
            axios.post(`${process.env.REACT_APP_API_URL}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then(response => {
                    console.log(response.data.status);
                    Swal.close();
                    if (response.data.status === true) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Advertiment Created',
                        }).then(() => {
                            const formAlldata = {
                                datebaseid: response.data.data,
                                // amount: TotalPay,
                                // description: 'Add Addvertisement',
                                // type: 'new'
                                action: "adAddPayment"
                            };
                            axios.post(`${process.env.REACT_APP_API_URL}stripe.php`, formAlldata)
                                .then((response22) => {
                                    localStorage.setItem('add_payment', JSON.stringify(response22.data.datebaseid));
                                    localStorage.setItem('orderId', JSON.stringify(response22.data.order_id));
                                    navigate('/payment');

                                })
                                .catch((error) => {
                                    console.error('Error fetching client secret:', error);
                                });
                        })
                    } else {
                        Swal.fire(
                            'Oops...m',
                            `Something went wrong creating the garage ${response.data.message}`,
                            'error'
                        );
                    }
                })
                .catch(error => {
                    Swal.close();
                    Swal.fire(
                        'Oops...m',
                        `Something went wrong creating the garage ${error}`,
                        'error'
                    );
                });


        }
    };

    return (
        <section className="page-content half-map sec-padding">
            <div className="container">
                <div className="sec-title row justify-content-center">
                    <h3>Advertise with GarageXY</h3>
                </div>
                <div className="col-md-10 mx-auto">
                    <div className="card AddressView">
                        <div className="card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="businessName"> Business Name <span className="text-danger">*</span></label>
                                    <div className="col-md-8 d-flex position-relative">
                                        <input name="businessName" type="text"
                                            className="form-control" {...register("businessName", { required: true })}
                                        />
                                        {errors.businessName &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Business Name is required!</span>
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="businessLicense"> Business License <span className="text-danger">*</span></label>
                                    <div className="col-md-8 d-flex position-relative">
                                        <input name="businessLicense" type="text"
                                            className="form-control" {...register("businessLicense", { required: true })}
                                        />
                                        {errors.businessLicense &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Business Licenseis required!</span>
                                            </span>
                                        }
                                    </div>
                                </div>
                                {/* <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="phoneNumber"> Mobile Phone <span className="text-danger">*</span></label>
                                    <div className="col-md-8 d-flex position-relative">
                                        <Controller
                                            control={control}
                                            name="phoneNumber"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <PhoneInput
                                                    defaultCountry="IN"
                                                    placeholder='(555) 555-5555'
                                                    onChange={(number) => field.onChange(number)}
                                                    className="form-control"
                                                    value={field.value}
                                                    maxLength='14'
                                                />
                                            )}
                                        />
                                        {errors.phoneNumber &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Mobile Phone is required!</span>
                                            </span>
                                        }
                                    </div>
                                </div> */}

                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="startDate"> Start Date <span className="text-danger">*</span></label>
                                    <div className="col-md-8 d-flex position-relative">
                                        {/* <DatePicker
                                            name="startDate"
                                            // selected={inputFields.startDate ? new Date(inputFields.startDate) : new Date()}
                                            className="form-control"
                                            onChange={(date) => handleChangeDate(date, 'startDate')}
                                            dateFormat="MM/dd/yyyy"
                                            placeholderText="MM/dd/yyyy"
                                            minDate={new Date()}
                                            showYearDropdown
                                            showMonthDropdown
                                            dropdownMode="select"
                                            {...register("startDate", { required: true })}
                                        /> */}
                                        <Controller
                                            control={control}
                                            name="startDate"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <DatePicker
                                                    selected={field.value}
                                                    onChange={(date) => {
                                                        field.onChange(date);
                                                        handleChange();
                                                    }}
                                                    dateFormat="MM/dd/yyyy"
                                                    placeholderText="MM/dd/yyyy"
                                                    minDate={new Date()}
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    dropdownMode="select"
                                                    className="form-control"
                                                />
                                            )}
                                        />
                                        {errors.startDate &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Start Date is required!</span>
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="adPicture"> Advertise image <span className="text-danger">*</span></label>
                                    <div className="col-md-8 d-flex position-relative justify-content-between">
                                        <Controller
                                            control={control}
                                            name="adPicture"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <>
                                                    <input
                                                        id="adPicture"
                                                        type="file"
                                                        className="form-file form-control"
                                                        accept=".jpg, .png, jpeg"
                                                        onChange={(e) => {
                                                            handleImageChange(e);
                                                            field.onChange(e.target.files[0]);
                                                        }}
                                                        ref={field.ref}
                                                    />
                                                    <label htmlFor="adPicture" className="btn btn-primary btn-lg">Choose a File</label>
                                                </>
                                            )}
                                        />


                                        {/* <input name="adPicture" id="adPicture" type="file"
                                            className="form-file form-control"
                                            {...register("adPicture", { required: true })}
                                            onChange={handleChange}
                                            accept=".jpg, .png, jpeg"
                                        />
                                        <label htmlFor="adPicture" className="btn btn-primary btn-lg" >Choose a File</label> */}

                                        {fileURL.length > 0 && <button className="btn btn-primary btn-lg" onClick={openImageModal}>File Preview</button>}

                                        {errors.adPicture &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Advertise image is required!</span>
                                            </span>
                                        }

                                    </div>
                                </div>

                                {fileURL.length > 0 &&
                                    <div className="modal fade" id="imagePreviewModal" tabIndex="-1" role="dialog">
                                        <div className="modal-dialog modal-xxl" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Image Preview</h5>
                                                    <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                                                        <span aria-hidden="true"></span>
                                                    </button>
                                                </div>
                                                <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                    <div className="row">
                                                        <header style={{ height: '250px' }}>
                                                            <div className="container-fluid">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 mb-2 mb-md-0 text-dark text-decoration-none  col-sm-12 col-xs-12">
                                                                        {/* <span style={{ fontSize: "2rem", position: "absolute", left: "-15px", top: 10 }}
                                                                        ><i className="la la-angle-left" />
                                                                        </span> */}
                                                                        <a href="/" title="">
                                                                            <img src="https://garagexy.com/API/images/garage-logo.png " alt="logo" /></a>
                                                                    </div>
                                                                    <div className="col-md-3 col-sm-12 col-xs-12 text-center">
                                                                        <nav><ul><li className="loginButton"><a href="#" className="Iconbig"><i className="la la-user "></i>
                                                                            <i className="la la-chevron-down "></i></a>
                                                                        </li></ul>
                                                                        </nav>
                                                                    </div>
                                                                    <div className="col-md-5 text-end col-sm-12 col-xs-12">
                                                                        <div className="text-center imgtinyDiv">
                                                                            <img src={fileURL[0].url} alt={`Preview`} style={{ transform: `rotate(${fileURL[0].rotationAngle}deg)` }} className="img-fluid mb-2 previewImg" />
                                                                            <div className="d-flex justify-content-around">
                                                                                <i onClick={() => rotateImage(0)} className="la la-refresh"></i>
                                                                                <i onClick={() => removeImage(0)} className="la la-trash"></i>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </header>
                                                        {/* <div className="col-md-6 d-flex justify-content-center align-items-center mb-3">
                                                            <div className="text-center">
                                                                <img src={fileURL[0].url} alt={`Preview`} style={{ transform: `rotate(${fileURL[0].rotationAngle}deg)`, width: "200px", height: "200px" }} className="img-fluid mb-2" />
                                                                <div className="d-flex justify-content-around">
                                                                    <i onClick={() => rotateImage(0)} className="la la-refresh"></i>
                                                                    <i onClick={() => removeImage(0)} className="la la-trash"></i>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>

                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closeModal}>Done</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="businessURL"> Business URL <span className="text-danger">*</span></label>
                                    <div className="col-md-8 d-flex position-relative">
                                        <input name="businessURL" type="url"
                                            className="form-control"
                                            {...register("businessURL", {
                                                required: "Business URL is required",
                                                pattern: {
                                                    value: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
                                                    message: "Please enter a valid URL",
                                                },
                                            })}
                                        />

                                        {errors.businessURL &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">{errors.businessURL.message}</span>
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div className="form-group row align-items-start">
                                    <label className="form-label col-md-4" htmlFor="ZipCodes"> ZipCodes <span className="text-danger">*</span><br /><br />
                                        <a className='btn btn-primary'
                                            href={`https://www.unitedstateszipcodes.org/`} target="_blank"
                                        >Zipcode Map </a>
                                    </label>
                                    <div className="col-md-8 row zipcodeall position-relative">
                                        {/* {inputValues.map((value, index) => (
                                            <div className="col-md-4 d-flex" key={index}>
                                                <input
                                                    name={`ZipCodes${index}`}
                                                    className="form-control" {...register(`ZipCodes${index}`, { required: index == 0 ? true : false })}
                                                    id={`ZipCodes${index}`}
                                                    type="number"
                                                    value={value}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>
                                        ))} */}

                                        {inputValues.map((value, index) => (
                                            <div className="col-md-4 d-flex" key={index}>
                                                <Controller
                                                    control={control}
                                                    name={`ZipCodes${index}`}
                                                    rules={{ required: index === 0 }}
                                                    render={({ field }) => (
                                                        <input
                                                            className="form-control"
                                                            id={`ZipCodes${index}`}
                                                            type="number"
                                                            value={field.value || (value === 0 ? "" : value)}
                                                            onChange={(e) => {
                                                                handleInputChange(index, e);
                                                                const inputValue = e.target.value === "" ? "" : parseInt(e.target.value, 10);
                                                                field.onChange(inputValue);
                                                                handleChange();
                                                            }}
                                                            ref={field.ref}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        ))}

                                        {errors.ZipCodes0 &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">ZipCodes is required!</span>
                                            </span>
                                        }

                                    </div>
                                    <div>
                                        <input type="hidden" id='MainPrice' value={count ? count * MainPrice : MainPrice} />
                                        <input type="hidden" id='discount' value={discount} />

                                        <div style={{ whiteSpace: 'pre-line' }}>
                                            {Array.isArray(uniqueArray) && uniqueArray.filter((item) => item !== '').map((item, index) => (
                                                <div key={index}>
                                                    <p className="zip-price">ZipCode: {item}&nbsp;| &nbsp;Price: ${MainPrice}</p>
                                                </div>
                                            ))}
                                            <>
                                                {count > 0 && <p className="total-new-zipcode">Total Zipcode(s): {count}</p>}
                                                {count > 0 && <p className="pay-total">You have to Pay Total: ${count * MainPrice}</p>}
                                            </>
                                            <p className="pay-total"></p>
                                        </div>
                                    </div>
                                    <input type="hidden" name="TotalPay" value={TotalPay} />

                                </div>
                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="PaymentType"> Payment Type <span className="text-danger">*</span></label>
                                    <div className="col-md-8 d-flex position-relative">
                                        {/* <div className="form-group me-2">
                                            <input
                                                className="btn-check"
                                                name="PaymentType"
                                                type="radio"
                                                value="MonthlyBilling"
                                                id="MonthlyBilling"
                                                {...register("PaymentType", { required: true })}
                                            />
                                            <label className="btn btn-outline-primary" htmlFor="MonthlyBilling">Monthly Billing</label>
                                        </div>

                                        <div className="form-group">
                                            <input
                                                className="btn-check"
                                                name="PaymentType"
                                                type="radio"
                                                value="YearlyBilling"
                                                id="YearlyBilling"
                                                {...register("PaymentType", { required: true })}
                                            />
                                            <label className="btn btn-outline-primary" htmlFor="YearlyBilling">Yearly Billing</label>
                                        </div> */}
                                        <div className="form-group me-2">
                                            <Controller
                                                control={control}
                                                name="PaymentType"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <>
                                                        <input
                                                            className="btn-check"
                                                            type="radio"
                                                            value="MonthlyBilling"
                                                            id="MonthlyBilling"
                                                            {...field}
                                                            onChange={(e) => {
                                                                field.onChange(e.target.id);
                                                                handleChange();
                                                            }}
                                                        />
                                                        <label className="btn btn-outline-primary" htmlFor="MonthlyBilling">Monthly Billing</label>
                                                    </>
                                                )}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <Controller
                                                control={control}
                                                name="PaymentType"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <>
                                                        <input
                                                            className="btn-check"
                                                            type="radio"
                                                            value="YearlyBilling"
                                                            id="YearlyBilling"
                                                            {...field}
                                                            onChange={(e) => {
                                                                field.onChange(e.target.id);
                                                                handleChange();
                                                            }}
                                                        />
                                                        <label className="btn btn-outline-primary" htmlFor="YearlyBilling">Yearly Billing</label>
                                                    </>
                                                )}
                                            />
                                        </div>

                                        {errors.PaymentType &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Payment Type is required!</span>
                                            </span>
                                        }

                                    </div>
                                </div>
                                <div className='dynamic_form__container__actions'>
                                    {yearlySelected && yearlySelected}
                                </div>
                                <div className="form-group text-center">
                                    <button type="submit" className="btn btn-primary btn-lg" >Add Advertisement</button>
                                </div>

                            </form>
                        </div>

                    </div>
                </div>
            </div >
        </section >
    )
}
